import React, { CSSProperties, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';

import Button from 'carbon-react/lib/components/button';
import Icon from 'carbon-react/lib/components/icon';

import { SheetsImportInfo } from '@futrli-sdk/predict';
import { UISystemIcon } from '@futrli/ui-components';

import { DeleteButton } from '../../controls/delete-button/delete-button';
import { MasterfileButton } from '../../controls/masterfile-button';
import { SyncButton } from '../../controls/sync-button/sync-button';
import styles from './import-title.scss';

interface ImportTitleProps {
  className?: string;
  disableSyncAll?: boolean;
  isSheetAccessible?: boolean;
  onSyncAll?: () => void;
  sheetInfo?: SheetsImportInfo | null;
  showBeta?: boolean;
  style?: CSSProperties;
  title?: ReactNode;
}

export const ImportTitle = ({
  className,
  disableSyncAll,
  isSheetAccessible = false,
  onSyncAll,
  sheetInfo,
  showBeta,
  style,
  title
}: ImportTitleProps) => {
  return (
    <div className={clsx(styles.title, className)} style={style}>
      <div className={styles.sheetsIcon}>
        <UISystemIcon iconName="gsheets-colored" width="32" height="40" />
      </div>
      <h1 className="uiTypeHeader">{title}</h1>
      {showBeta && (
        <Button disabled={true} m="0 16px">
          <FormattedMessage id="import.beta" defaultMessage="Beta" />
        </Button>
      )}
      {isSheetAccessible && sheetInfo && (
        <MasterfileButton
          className={styles.masterFileBtn}
          onClick={() => window.open(sheetInfo?.sheet_url, '_blank')}
          testId="open-master-sheet"
        >
          <FormattedMessage id="import.open_master_sheet" defaultMessage="Open Master Sheet" />
        </MasterfileButton>
      )}
      {isSheetAccessible && (
        <>
          <DeleteButton />
          <SyncButton />
        </>
      )}
      {onSyncAll && (
        <div className={styles.syncAllContainer}>
          <Button className={styles.syncAll} buttonType="primary" onClick={onSyncAll} disabled={disableSyncAll}>
            <Icon type="sync" />
            <FormattedMessage id="import.sync_all_import_templates" defaultMessage="Sync all import templates" />
          </Button>
        </div>
      )}
    </div>
  );
};
